import { useRef } from "react";
import DashboardComponentWrapper from "../../components/dashboard/DashboardComponentWrapper";
import TabComponent from '../../components/ui/TabComponent';
import SecuritySettingsForm from "./SecurityConfiguration";
import DashboardNavItem from "../../components/dashboard/DashboardNavItem/DashboardNavItem";
import { icons } from '../../assets';

const Settings = () => {
  const tabComponents = {
    'Options': () => <SecuritySettingsForm />,
  };
  
  const currentTabRef = useRef(Object.keys(tabComponents)[0]);
  
  const navItems = [
    {
      label: 'New Workflow',
      action: () => {},
      bgColor: '#0898A0',
      img: icons.createIcon,
    }
  ]

  const renderNavItems = () => {
    return (
      <DashboardNavItem
        navItems={[]}
        navItemsObj={currentTabRef.current === 'Workflow Management' ? navItems : []}
        tab={''}
        setTab={() => {}}
      />
    )
  }

  return (
      <DashboardComponentWrapper
        title="App Configurations"
        pageDetails="Application configuration page"
        renderNavItems={renderNavItems}
      >
        <>
            <TabComponent
              components={tabComponents}
            />
        </>
      </DashboardComponentWrapper>
  )
};

export default Settings;